import { Link } from "react-router-dom";
import shoppingcart from "./shoppingcart.png";
import addtocart from "./addtocart.png";

import { useState, useEffect } from "react";

const Sub_kichen_home = () => {

  const [getstoreName, setstoreName] = useState("Sub Stock");
  useEffect(() => {
    const storeName = localStorage.getItem("selectedStore");
    if (storeName) {
      setstoreName(storeName);
    }
  }, []);
  return (
    <>
      <div class="content">
        <div class="container-fluid">
          <div class="row g-3">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <div className="row">
                    <div className="col py-2">
                      <Link to="/subKitchen" className="text-decoration-none">
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              {getstoreName}
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Stock value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={shoppingcart}
                                  alt="shoppingcart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                    <div className="col py-2">
                      <Link
                        to="/ExpenditureListSubKitchen"
                        className="text-decoration-none"
                      >
                        <div className="card overflow-hidden h-100">
                          <div
                            className="bg-holder bg-card"
                            style={{
                              backgroundImage: "url(images/corner-7.png)",
                            }}
                          ></div>
                          <div className="card-body position-relative">
                            <h6 className="d-flex flex-between-center mono-card-text">
                              Expenditure
                            </h6>
                            <div className="d-flex flex-between-center">
                              <div>
                                <div
                                  className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                                  id="totalState"
                                >
                                  {/* Expenditure value here */}
                                </div>
                              </div>
                              <div>
                                <img
                                  src={addtocart}
                                  className=""
                                  alt="addtocart"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const DashboardCard = ({ title, to, logo }) => (
  <Link to={to} style={{ textDecoration: "none" }}>
    <div className="col py-2">
      <div className="card overflow-hidden h-100" style={{ cursor: "pointer" }}>
        <div
          className="bg-holder bg-card"
          style={{ backgroundImage: "url(images/corner-7.png)" }}
        ></div>
        <div className="card-body position-relative">
          <h6 className="d-flex flex-between-center mono-card-text">{title}</h6>
          <div className="d-flex flex-between-center">
            <div>
              <div
                className="display-2 fs-2 fw-normal font-sans-serif text-warning"
                id="totalState"
              >
                {/* Insert value here if needed */}
              </div>
            </div>
            <div>
              <img src={logo} className="" alt="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Link>
);
export default Sub_kichen_home;
